module.exports = "<div class=\"left-sidebar\">\n    <app-sidebarmenu current_state=\"profile\"></app-sidebarmenu>\n</div>\n<div class=\"right-content\">\n    <app-app-header current_state=\"profile\"></app-app-header>\n    <app-userprofile></app-userprofile>\n    <app-copy-right></app-copy-right>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/app/components/profile/profile.component.html
// module id = ../../../../../src/app/components/profile/profile.component.html
// module chunks = main